module.exports = __webpack_public_path__ + "static/media/11.final.1955736c.mp4";